import React, { useState, useEffect, useRef } from 'react';
import CardCount from './cardCount';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { StyledText } from '../Utils/TextStyles';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: 10,
    marginTop: 5,
    maxWidth: 400,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export const Countdown = () => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [inputDate, setInputDate] = useState('25 Nov 2023 17:00:00');
  const [currentDate, setCurrentDate] = useState(inputDate);
  let interval = useRef();
  const classes = useStyles();

  useEffect(() => {
    iniciaContador();
    return () => {
      clearInterval(interval);
    };
  });

  function formatTime(time) {
    return time < 10 ? `0${time}` : time;
  }

  const iniciaContador = () => {
    const changingDate = new Date(inputDate);
    const currentDate = new Date();
    interval = setInterval(() => {
      const totalSeconds = (changingDate - currentDate) / 1000;
      setDays(formatTime(Math.floor(totalSeconds / 3600 / 24)));
      setHours(Math.floor(totalSeconds / 3600) % 24);
      setMinutes(Math.floor(totalSeconds / 60) % 60);
      setSeconds(Math.floor(totalSeconds % 60));
    }, 1000);
  };

  return (
    <div className={classes.root}>
      <StyledText
        color='#00774f'
        style={{ justifyContent: 'center', display: 'flex' }}
      >
        25 de Noviembre 2023
      </StyledText>
      <Grid container spacing={0}>
        <Grid item xs={3} sm={3}>
          <CardCount title='Dias' value={days} color='1' />
        </Grid>
        <Grid item xs={3} sm={3}>
          <CardCount title='Horas' value={hours} color='2' />
        </Grid>
        <Grid item xs={3} sm={3}>
          <CardCount title='Min' value={minutes} color='1' />
        </Grid>
        <Grid item xs={3} sm={3}>
          <CardCount title='Seg' value={seconds} color='2' />
        </Grid>
      </Grid>
    </div>
  );
};
